import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { ReclamationSuccess } from "../../components";
export var ReclamationSuccessPage = function () {
    var _a, _b;
    var searchParams = useSearchParams()[0];
    var protocol = (_a = searchParams.get("protocol")) !== null && _a !== void 0 ? _a : "";
    var id = (_b = searchParams.get("id")) !== null && _b !== void 0 ? _b : undefined;
    return _jsx(ReclamationSuccess, { protocol: protocol, id: id });
};
